import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, TextInput } from '@simplybenefits/sb-ui-library';
import { updateChangeRequest } from '../../actions/administration';
import { changeStatusDisplay } from '../../constants/administration';

/**
 *
 * @param name
 * @param currentValue
 * @param assignedToMap
 * @param changeRequestID
 * @param onClose
 * @param loader
 * @param dispatch
 * @param fetchChangeRequests
 * @returns {JSX.Element}
 * @constructor
 */
const EditChangeRequestField = ({ name, currentValue, assignedToMap, changeRequestID, onClose, loader, dispatch, fetchChangeRequests }) => {
    const pendingStatuses = [ 'Pending Member Review', 'Pending Admin Review', 'Pending Agent Review' ];

    const modal = {
        reassign: {
            isConfirmationModal: false,
            title: 'Reassign Administrator',
            field: 'assignedTo',
            buttonLabel: 'Reassign',
            currentLabel: 'Current Administrator',
            newLabel: 'New Administrator',
            currentValue,
            newValueOptions: Object.keys(assignedToMap),
            convertForDispatch: (v) => assignedToMap[v],
            convertForDisplay: (v) => v === null ? 'Unassigned' : v
        },
        changeStatus: {
            isConfirmationModal: false,
            title: 'Change Status',
            field: 'status',
            buttonLabel: 'Save Status',
            currentLabel: 'Current Status',
            newLabel: 'New Status',
            currentValue,
            newValueOptions: changeStatusDisplay,
            convertForDispatch: (v) => v,
            convertForDisplay: (v) => pendingStatuses.includes(v) ? 'Pending' : v
        }
    }[name];

    modal.currentValue = modal.convertForDisplay(currentValue);
    const [ newValue, setNewValue ] = useState(modal.currentValue);

    /**
     *
     * @returns {Promise<void>}
     * @private
     */
    const _updateChangeRequest = async () => {
        const body = { [modal.field]: modal.convertForDispatch(newValue) };
        await dispatch(updateChangeRequest(changeRequestID, body));
        await fetchChangeRequests(0);
        onClose();
    };

    return (
        <Modal
            open={ true }
            title={ modal.title }
            onClose={ onClose }
            loader={ loader }
            primaryButton={{
                color: 'primary',
                label: modal.buttonLabel,
                onClick: _updateChangeRequest
            }}
        >
            <TextInput
                label={ modal.currentLabel }
                fullWidth
                value={ modal.currentValue }
                variant="outlined"
                disabled
                select
                selectOptions={ modal.newValueOptions }
            />

            <TextInput
                label={ modal.newLabel }
                fullWidth
                value={ newValue }
                variant="outlined"
                select
                onChange={(e) => setNewValue(e.target.value)}
                selectOptions={ modal.newValueOptions }
            />
        </Modal>
    );
};

export default connect()(EditChangeRequestField);